"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileService = void 0;
const APIService_1 = require("./APIService");
const search = (q) => APIService_1.APIService.get(`/profiles`, {
    params: {
        q,
    },
});
const getProfile = (slug) => APIService_1.APIService.get(`/profile/${slug}`);
const getProfiles = (page, size) => APIService_1.APIService.get(`/profiles?page=${page}&size=${size}`);
const getProfilesByProvince = (province, page, size) => APIService_1.APIService.get(`/profiles?province=${province}&page=${page}&size=${size}`);
const getProfilesByCity = (province, city, page, size) => APIService_1.APIService.get(`/profiles?province=${province}&city=${city}&page=${page}&size=${size}`);
exports.ProfileService = {
    getProfilesByProvince,
    getProfilesByCity,
    getProfiles,
    getProfile,
    search,
};
//# sourceMappingURL=ProfileService.js.map